export function formatDate(d){
    var h = d.getHours();
    var m = d.getMinutes();
    var s = d.getSeconds();
    var Y = d.getFullYear();
    var M = d.getMonth() + 1;
    var D = d.getDate();

    return `${Y}-${addZero(M)}-${addZero(D)} ${addZero(h)}:${addZero(m)}:${addZero(s)}`
}

export function formatDate1(d){
    d.setDate(d.getDate() + 1);
    return formatDate(d);
}

export function formatDateT(d,n) {
    d.setDate(d.getDate() + n);
    var h = d.getHours();
    var m = d.getMinutes();
    var s = d.getSeconds();
    var Y = d.getFullYear();
    var M = d.getMonth() + 1;
    var D = d.getDate();

    return `${Y}-${addZero(M)}-${addZero(D)}T${addZero(h)}:${addZero(m)}:${addZero(s)}`
}

export function renderDate(d){
    var Y = d.getFullYear();
    var M = d.getMonth() + 1;
    var D = d.getDate();

    return `${addZero(D)}/${addZero(M)}/${Y}`
}

export function cutDate(d){
    let cd = d.slice(0, -11)
    var D = cd.substr(8,2);
    var M = cd.substr(5,2);
    var Y = cd.substr(0,4);
    return `${D}/${M}/${Y}`
}

export function genDate(d){
    let dg = new Date(d);
    var h = dg.getHours();
    var m = dg.getMinutes();
    var s = dg.getSeconds();
    var Y = dg.getFullYear();
    var M = dg.getMonth() + 1;
    var D = dg.getDate();

    return `${Y}-${addZero(M)}-${addZero(D)}T${addZero(h)}:${addZero(m)}:${addZero(s)}`
}

export function renderStrDate(d){
    var h = d.getHours();
    var m = d.getMinutes();
    var Y = d.getFullYear();
    var M = d.getMonth() + 1;
    var D = d.getDate();

    return `lúc ${addZero(h)}:${addZero(m)} ngày ${addZero(D)}/${addZero(M)}/${Y}`
}

function addZero(num) {
    if(num < 10){
       return "0" + num;
    }
    return num;
}


export function convertXxtea(data){
    var xxtea = require('xxtea-node');
    var str = JSON.stringify(data);
    var key = "277dafc255e959a21f4dd5a9c3bbe760";
    var encrypt_data = xxtea.encryptToString(str, key);
    return encrypt_data
}


export function setLocalStore(key, value) {
    localStorage.setItem(key, value);
}

export function getLocalStore(key) {
    return localStorage.getItem(key);
}

export function deleteLocalStore(key) {
    localStorage.removeItem(key);
}

export function clearLocalStore() {
    localStorage.clear();
}

export function formatDataMembers(listMem){
    let listContact = [];
    for (var i = 0; i < listMem.length; i++) {
        if (listMem[i] == null) {
            console.log('null');
        } else {
            listContact.push({
                'lastChangeAvatar' : listMem[i].avatar,
                'contactName' : listMem[i].name,
                'msisdn' : listMem[i].username,
                "nickName":"",
                "fullAvatar":""
            });
        }
    }

    return listContact;
}

export function getPhone(listMem){
    let listContact = [];
    for (var i = 0; i < listMem.length; i++) {
        if (listMem[i] == null) {
            console.log('null');
        } else {
            listContact.push(listMem[i].username);
        }
    }

    return listContact;
}